if (!customElements.get('product-collection-picker')) {
  customElements.define(
    'product-collection-picker',
    class ProductCollectionPicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.handleChange.bind(this));
      }

      handleChange(event) {
        const target = event.target.closest('input, select');

        if (!target?.dataset.productUrl) return;

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            // The product switcher is not a real variant option.
            // Let the destination product choose its first available variant.
            selectedOptionValues: [],
          },
        });
      }
    }
  );
}